// extracted by mini-css-extract-plugin
module.exports = {"filtersButton":"filters-button_filtersButton__WPS6x","filtersButton__label":"filters-button_filtersButton__label__HmNJK"};